import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { LoadPopupPanel } from '../../../../components';
import { useGetOutOfStockOrders } from '../api/get-out-of-stock-orders';
import OutOfStockOrdersGrid from './OutOfStockOrdersGrid';
import { useSetOOSEstimatedDeliveryDateParams } from '../api/set-oos-estimated-delivery-date';
import { SetOOSEstimatedDeliveryDateParams } from '../types/SetOOSEstimatedDeliveryDateParams';
import { showErrorMessage, showSuccessMessage } from '../../../../utils/messages';

export default function OutOfStockOrdersPopup(props: { visible: boolean, productID: number, onHidden: () => void }) {
	const orders = useGetOutOfStockOrders(props.productID);
	const handleSuccess = () => {
		showSuccessMessage('Estimated delivery dates updated successfully.');
		props.onHidden();
	};
	
	const handleError = (error: string) => {
		showErrorMessage(error);
	};
	
	const submitDeliveryDates = useSetOOSEstimatedDeliveryDateParams({
		OutOfStocks: orders.data,
		onSuccess: handleSuccess,
		onError: handleError,
	});
	
	const handleSubmit = () => {
		submitDeliveryDates.mutate({ 
			OutOfStocks: orders.data, 
			onSuccess: handleSuccess, 
			onError: handleError 
		});
	};
		
	return (
		<Popup
			title="Purchase Orders"
			visible={props.visible}
			hideOnOutsideClick
			onHiding={props.onHidden}>
			
			<ToolbarItem
				options={{
					icon: 'dx-icon dx-icon-close',
					onClick: props.onHidden,
				}}
				widget="dxButton"
				location="after" />

			<ToolbarItem
				options={{
					text: 'OK',
					onClick: handleSubmit,
				}}
				toolbar="bottom"
				widget="dxButton"
				location="after" />

			<ToolbarItem
				options={{
					text: 'Cancel',
					onClick: props.onHidden,
				}}
				toolbar="bottom"
				widget="dxButton"
				location="after" />

			{props.visible && <OutOfStockOrdersGrid records={orders.data} />}
			<LoadPopupPanel visible={orders.isLoading} />
		</Popup>
	);
} 
